export const reports_dashboard_computed = {
  active_drawer() {
    return this.drawer_catalog[this.active_drawer_key] || null;
  },
  active_drawer_footer_primary_actions() {
    const actions = this.active_drawer?.footer_actions || [];
    const has_explicit_positions = actions.some((action) => action.position);
    return has_explicit_positions ? actions.filter((action) => action.position === 'left') : [];
  },
  active_drawer_footer_actions() {
    const actions = this.active_drawer?.footer_actions || [];
    const has_explicit_positions = actions.some((action) => action.position);
    return has_explicit_positions ? actions.filter((action) => action.position !== 'left') : actions;
  }
};

export const reports_dashboard_methods = {
  set_tab(tab_id) {
    this.active_tab = tab_id;
    this.close_drawer();
  },
  open_drawer(drawer_key) {
    if (!drawer_key) return;
    this.active_drawer_key = drawer_key;
    this.$nextTick(() => {
      const drawer_body = this.$refs.drawerBody;
      if (drawer_body) drawer_body.scrollTop = 0;
    });
  },
  reset_sample() {
    this.active_tab = 'decisions-required';
    this.close_drawer();
  },
  close_drawer() {
    this.active_drawer_key = null;
  }
};
